<template>
  <div class="chart-result-wrapper">

    <div class="chart-header-card">
      <div class="chart-info-left">
        <h2 class="chart-title">{{ horoscope.criteria.client }}</h2>
        <div class="chart-meta">
          <span class="meta-value">{{ horoscope.criteria.dateInfo }}</span>
        </div>
        <div class="chart-meta">
          <span class="meta-value">{{ horoscope.criteria.location }}</span>
        </div>
      </div>
  </div>



    <!-- Chart Images -->
    <div class="chart-images">
      <img ref="d1_chart_image" :src="horoscope.chartImages.imageMap.D1" alt="D1" class="chart-img">
      <img ref="d9_chart_image" :src="horoscope.chartImages.imageMap.D9" alt="D9" class="chart-img">
    </div><!-- Planetary Summary Table -->

    <div class="chart-style-toggle">
      <!-- On change -->
      <label
        v-for="option in chartStyleOptions"
        :key="option.value"
        :class="['radio-pill', { selected: this.horoscope.criteria.chartStyle === option.value }]"
      >
        <input
          type="radio"
          :value="option.value"
          v-model="this.horoscope.criteria.chartStyle"
          @change="updateChartStyle(option.value)"
        />
        {{ option.label }} 
        <template v-if="option.value == 0">
          &nbsp;<font-awesome-icon :icon="['fas', 'square']" size="lg" />&nbsp;
        </template>
        <template v-else>
          &nbsp;<font-awesome-icon :icon="['fas', 'diamond']" size="lg" />&nbsp;
        </template>

        
      </label>
  </div>   

<div class="planet-table-wrapper">
  <table class="planet-table">
    <thead>
      <tr>
        <th>Planet</th>
        <th>Degree</th>
        <th>Zodiac</th>
        <th>House</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="planet in horoscope.planets.planets" :key="planet.name">
        <td style="text-align: left;">
          {{planet.name}} &mdash; {{planet.shortName}}
        </td>
        <td>{{ formatDegree(planet.relativeDegreeDMS) }}</td>
        <td>{{ planet.zodiacSignName }}</td>
        <td>{{ planet.houseNumber }}</td>
      </tr>
    </tbody>
  </table>
</div>

<div class="report-recommendation-wrapper" v-if="horoscope.reportRecommendations && horoscope.reportRecommendations.length">
  <div class="features">
    <h2 style="text-align: left; margin-top: 20px; margin-bottom: 20px;">What Your Chart Reveals</h2>

    <p style="text-align: justify;">
      Based on the following patterns, we recommend exploring the <b>premium astrology reports</b> to gain deeper insights.
    </p>

    <ul>
      <li v-for="(recommendation, index) in horoscope.reportRecommendations" :key="index">
        {{ recommendation }}
      </li>
    </ul>
  </div>
</div>



<div class="cta-button-group">
  <button @click="activateMenuItem('home')" class="cta-btn cta-free">Edit Birth Details</button>
  <button @click="activateMenuItem('paid-report')" class="cta-btn cta-paid" title="Get deeper insights with your personalized premium report">Unlock Your Premium Reports</button>
  <button @click="activateMenuItem('free-report')" class="cta-btn cta-free" title="Instant access to your personalized birth chart analysis and insights">Read Your Free Report</button>  
  <button @click="downloadBasicNatalChartPDF()" class="cta-btn cta-free" title="Instant access to your personalized birth chart analysis and insights">Download Your Free Chart</button>
</div>

  </div>
</template>

<script>

import HTTP from "../http-axios.js";
import ApiBaseUrl from "@/http-api-base-url";
import { queryString, criteriaToken } from "../util.js";

export default {
	components: {  },
	props: {
		horoscope : {
			type: Object
		}
	},
	data() {
		return {
      chartStyleOptions: [
                { value: 0, label: '' },
                { value: 1, label: '' }
              ],
      pdfUrl: "",
      htmlDownloadUrl: "",

		}
	},
	created() {
	},
  mounted() {
    window.scrollTo(0, 0); // Instantly scroll to top when component is mounted
  },
	methods: {
    formatDegree(dms) {
      return dms.replace(/\.\d+$/, '');
    },   
		activateMenuItem( activeMenuItem ) {
			this.$emit('activeMenuItem', activeMenuItem);
		},
    updateChartStyle(newStyle) {
      this.getHoroscope();
    },
    queryString: function (obj) {
      return queryString(obj);
    },
    getHoroscope: function() {
			HTTP().post(`/site/var/api/data/horoscope?` + this.queryString(this.horoscope.criteria))
			.then(response => {
				let newHoroscope = response.data
        this.$refs.d1_chart_image.src = newHoroscope.chartImages.imageMap.D1;
        this.$refs.d9_chart_image.src = newHoroscope.chartImages.imageMap.D9;
        this.$emit('userSelectedChartStyle', newHoroscope.criteria.chartStyle);
        this.$emit('horoscope', newHoroscope);
			})
			.catch(e => {
				console.log(e)
			})
		},
		downloadBasicNatalChartPDF() {
      this.pdfUrl = ApiBaseUrl() + "/site/var/api/pdf/natalchart_basic?" + this.queryString(this.horoscope.criteria) + "&ct=" + this.getCriteriaToken(this.horoscope.criteria);
			HTTP().get(this.pdfUrl, { responseType: 'blob' })
			.then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' })
				const link = document.createElement('a')
				link.href = URL.createObjectURL(blob)
				link.download = new String(this.horoscope.criteria.client ? this.horoscope.criteria.client : "Vedic Astrology Report - Natal Chart");
				link.click()
				URL.revokeObjectURL(link.href)
			}).catch(console.error)
		},
    getCriteriaToken: function() {
            return criteriaToken(this.horoscope.criteria);
    },
	}
}
</script>

<style scoped>
.chart-result-wrapper {
  padding: 20px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chart-images {
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin-bottom: 40px;
}
@media (min-width: 768px) {
  .chart-images {
    flex-direction: row;
  }
}

.chart-img {
  width: 100%;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.planet-table-wrapper {
  width: 100%;
  max-width: 768px;
  overflow-x: auto;
  margin-bottom: 10px;
  background-color: #f9f9f9;
  padding: 5px;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
}

.planet-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
  color: #333;
  background-color: #fff;
  min-width: 600px; /* Ensures horizontal scroll on very small screens */
}

.planet-table th,
.planet-table td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  white-space: nowrap; /* Prevents cell content from wrapping */
}

.planet-table th {
  background-color: #344E41;
  color: #fff;
  border-bottom: 2px solid #e0e0e0;
}

.planet-table tr:nth-child(even) {
  background-color: #f5f7fa;
}

.planet-table tr:hover {
  background-color: #eef3fc;
}

/* Mobile responsiveness */
@media screen and (max-width: 480px) {
  .planet-table-wrapper {
    padding: 12px;
  }

  .planet-table {
    font-size: 13px;
    min-width: 100%;
  }

  .planet-table th,
  .planet-table td {
    padding: 8px 10px;
  }
}


.planet-table th {
  border: 1px solid #ccc;
  padding: 8px 8px;
  text-align: center;
  font-size: 14px;
}

.planet-table td {
  border: 1px solid #ccc;
  padding: 8px 12px;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
}


@media (max-width: 967px) {
  .chart-images {
    flex-direction: column;
  }  

  .cta-btn {
    width: 100%;
    font-size: 18px;
  }

  .cta-button-group {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
  }    
}

button:hover {
    background-color: #3a7bd5;
}

.cta-button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-top: 24px;
}

.cta-btn {
  padding: 12px 24px;
  font-size: 18px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 200px;
  text-align: center;
}

/* Free Button Style */
.cta-free {
  background-color: #344E41;
  color: #FFF;
  font-weight: bold;
  border: 2px solid transparent;
}

/* Paid Button Style */
.cta-paid {
  background-color: #344E41;
  color: #fff;
  font-weight: bold;
  border: 2px solid transparent;
}

/* Mobile Friendly */
@media screen and (max-width: 480px) {
  .cta-btn {
    min-width: 100%;
    font-size: 18px;
  }

  .cta-button-group {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
  }  
}

/* Mobile Friendly */
@media screen and (width: 1200px) {

  .cta-btn {
    width: 100%;
    font-size: 18px;
  }

  .cta-button-group {
    width: 40%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
  }  
}

.chart-header-card {
  width: 100%;
  max-width: 768px;
  background: #d7f3d5;
  border-left: 6px solid #344E41;
  border-radius: 10px;
  padding: 5px 10px;
  margin-bottom: 30px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.07); /* Enhanced shadow */
}

.chart-info-left {
  text-align: left;
}

.chart-title {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 14px;
  color: #2c3e50;
}

.chart-meta {
  margin-bottom: 10px;
  font-size: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.meta-label {
  font-weight: 600;
  color: #555;
  min-width: 150px;
}

.meta-value {
  color: #333;
}

/* ✅ Mobile Responsiveness */
@media screen and (max-width: 480px) {
  .chart-header-card {
    padding: 6px;
    margin-bottom: 20px;
    border-left-width: 5px;
  }

  .chart-title {
    font-size: 20px;
  }

  .meta-label {
    min-width: 120px;
    font-size: 15px;
  }

  .meta-value {
    font-size: 17px;
  }

  .chart-meta {
    flex-direction: column;
  }
}

.chart-style-toggle {
  display: flex;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  justify-content: center;
  border: 0px solid;
}

.radio-pill {
  padding: 10px 18px;
  border: 2px solid #344E41;
  border-radius: 30px;
  cursor: pointer;
  user-select: none;
  font-weight: 600;
  color: #344E41;
  background-color: white;
  transition: all 0.3s ease;
}

.radio-pill input[type="radio"] {
  display: none;
}

.radio-pill.selected {
  background-color: #344E41;
  color: white;
}

.report-recommendation-wrapper {
  width: 100%;
  max-width: 768px;
  overflow-x: auto;
  margin-bottom: 10px;
  padding: 5px;
}

.features ul {
  padding-left: 20px;
  list-style: disc;
  margin-top: 15px;
  text-align: left;
}

.features li {
  margin-bottom: 10px;
  font-size: 15px;
}

</style>